import { Config } from "@config";
import React from "react";
import type { ReactNode } from "react";
import { LandingContainer } from "./components/LandingContainer";

/**
 * @Routing
 *
 * @title "Üzletszabályzat"
 * @description "A Bankmonitor Partner Kft. általános szerződési feltételeket is tartalmazó, pénzügyi szolgáltatás közvetítésére vonatkozó üzletszabályzata"
 * @route "/uzletszabalyzat/"
 */
export default class Landing extends React.PureComponent {
	public render(): ReactNode {
		return (
			<LandingContainer size="lg">
				<h1 className="display-1 display-bold">Üzletszabályzat</h1>
				<p className="display-4 pb-2">
					A Bankmonitor Partner Korlátolt Felelősségű Társaság általános szerződési feltételeket is
					tartalmazó, pénzügyi szolgáltatás közvetítésére vonatkozó üzletszabályzata
				</p>
				<p>Hatályos 2017. március 21. napjától</p>
				<p>
					A jelen – általános szerződéses feltételeket is magában foglaló – üzletszabályzat (a továbbiakban: "
					<strong>Üzletszabályzat</strong>") a hitelintézetekről és pénzügyi vállalkozásokról szóló 2013. évi
					CCXXXVII. törvény (a továbbiakban: "<strong>Hpt.</strong>") alapján a Bankmonitor Partner Korlátolt
					Felelősségű Társaság (cégjegyzékszám: Cg.01-09-170218; székhely: 1037 Budapest, Montevideo utca
					16/B.; a továbbiakban: "<strong>Többes Ügynök</strong>") független többes ügynöki tevékenységére
					vonatkozó általános szerződési feltételeket tartalmazza.
				</p>
				<h2 className="h1 mb-lg-4 mb-md-3 mb-2">I. Bevezető rendelkezések</h2>
				<ol>
					<li className="pb-2">
						A Többes Ügynök a Hpt. 10. § (1) bekezdés bb) alpontja szerinti többes ügynöknek minősülő
						független közvetítő, mely ügynöki tevékenységként több pénzügyi intézmény egymással versengő
						pénzügyi szolgáltatása vonatkozásában a Hpt. 3. § (1) bekezdés i) pontja szerint pénzügyi
						szolgáltatás közvetítését végzi.
					</li>
					<li className="pb-2">
						A Többes Ügynök a pénzügyi intézményekkel kötött megbízási szerződés alapján pénzügyi
						szolgáltatás nyújtásának, ilyen szolgáltatásra irányuló szerződés megkötésének elősegítésére
						irányuló tevékenységet végez, amelynek során a pénzügyi intézmény kockázatára önállóan
						kötelezettséget nem vállal, szerződést nem köt. A Többes Ügynök tevékenysége a Hpt. 6. § 90.
						pont e) alpontjában meghatározott jelzáloghitel közvetítői tevékenységre is kiterjed. A Többes
						Ügynök a Hpt. 3. § (2) bekezdés f) pontjában és 6. § (1) bekezdés 42a. pontjában meghatározott
						hiteltanácsadási tevékenységet nem végez.{" "}
					</li>
					<li className="pb-2">
						A Többes Ügynök kizárólag a{" "}
						<a href="https://www.mnb.hu/web/fooldal" target="_blank" rel="noreferrer">
							Magyar Nemzeti Bank
						</a>{" "}
						(a továbbiakban: "MNB") engedélyével végezheti többes ügynöki tevékenységét.{" "}
					</li>
					<li className="pb-2">
						A Többes Ügynök adatai: <br />
						<br />
						<strong>Cégnév:</strong> Bankmonitor Partner Korlátolt Felelősségű Társaság
						<br />
						<strong>Cégjegyzékszám:</strong> Cg.01-09-170218
						<br />
						<strong>Adószám:</strong> 24290353-2-41
						<br />
						<strong>Székhely:</strong> 1037 Budapest, Montevideo utca 16/B.
						<br />
						<strong>Felügyeleti hatóság:</strong>{" "}
						<a href="https://www.mnb.hu/web/fooldal" target="_blank" rel="noreferrer">
							Magyar Nemzeti Bank
						</a>
						<br />
						<strong>Felügyeleti hatóság címe:</strong> 1054 Budapest, Szabadság tér 9.
						<br />
						<strong>Felügyeleti hatóság engedélyező határozatainak száma:</strong> H-EN-I-527/2013. és
						H-EN-I-224/2017.
						<br />
						<strong>Felügyeleti hatóság engedélyező határozatainak kelte:</strong> 2013. május 28. és 2017.
						március 17.
						<br />
						<strong>Vezető állású személy [Hpt. 6. § (1) 122.]:</strong> Sándorfi Balázs
						<br />
						<strong>Fogyasztóvédelmi kapcsolattartó [Hpt. 288.§ (5)]:</strong> Sándorfi Balázs
					</li>
				</ol>
				<p>
					Tájékoztatjuk, hogy a Bankmonitor Partner Korlátolt Felelősségű Társaság az MNB Többes ügynök
					nyilvántartásában szerepel, amely az MNB honlapján ellenőrizhető:{" "}
					<a
						href="https://www.mnb.hu/felugyelet/engedelyezes-es-intezmenyfelugyeles/piaci-szereplok-keresese"
						target="_blank"
						rel="noreferrer"
					>
						https://www.mnb.hu/felugyelet/engedelyezes-es-intezmenyfelugyeles/piaci-szereplok-keresese
					</a>
				</p>
				<h2 className="h1 mb-lg-4 mb-md-3 mb-2">II. Az Üzletszabályzat hatálya és módosítása </h2>
				<p>
					Az Üzletszabályzat <strong>személyi</strong> hatálya kiterjed a jelen Üzletszabályzat alábbi III. 3.
					pontjában meghatározott ügyfélre (a továbbiakban: "<strong>Ügyfél</strong>") és a Többes Ügynökre (a
					továbbiakban együtt: "<strong>Felek</strong>").
				</p>
				<p>
					Az Üzletszabályzat, illetőleg annak módosítása a Többes Ügynök ügyfélforgalom számára nyitva álló
					üzlethelyiségében (1037 Budapest, Montevideo utca 16/B.) való közzétételt követő naptári nap 0
					órakor lép hatályba.
				</p>
				<p>
					Ettől az időponttól a Többes Ügynök honlapján (
					<a href="https://bankmonitor.hu" target="_blank">
						www.bankmonitor.hu
					</a>
					) is megtekinthető a hatályos Üzletszabályzat.
				</p>
				<p>
					Az Üzletszabályzat <strong>tárgyi</strong> hatálya kiterjed a Többes Ügynök által többes ügynökként
					végzett pénzügyi szolgáltatás közvetítési, valamint a jelzáloghitel közvetítői tevékenységre.
				</p>
				<p>
					A Többes Ügynök az Üzletszabályzatot bármikor egyoldalúan módosíthatja. Az Ügyfelek a Többes Ügynök
					módosított Üzletszabályzatának tervezetét nyomtatott formában a Többes Ügynök Ügyfelek számára
					nyitva álló helyiségében (1037 Budapest, Montevideo utca 16/B.) a jelen Üzletszabályzat 7.1.
					pontjában meghatározott nyitvatartási időben, vagy a Többes Ügynök honlapján (
					<a href="https://bankmonitor.hu">www.bankmonitor.hu</a>) a hatályba lépést megelőző 30 nappal
					megtekinthetik.
				</p>
				<h2 className="h1 mb-lg-4 mb-md-3 mb-2">III. Fogalmak, értelmező rendelkezések</h2>
				<h3 className="pb-2">1. Többes Ügynök:</h3>
				<p>
					A Többes Ügynök fogalmát a Hpt. 10. § (1) bekezdés bb) alpontja definiálja, mely szerint Többes
					Ügynök az a{" "}
					<i>
						„közvetítő, aki az e törvényben foglaltaknak megfelelően a pénzügyi szolgáltatás közvetítését
						ügynöki tevékenységként több pénzügyi intézmény egymással versengő pénzügyi szolgáltatása
						vonatkozásában (a továbbiakban: többes ügynök) végez”.
					</i>
				</p>
				<p>
					A Többes Ügynök által végzett ezen ügynöki tevékenység magában foglalja a Pénzügyi Intézménnyel
					kötött megbízási szerződés alapján pénzügyi szolgáltatás, kiegészítő pénzügyi szolgáltatás
					nyújtásának, ilyen szolgáltatásra irányuló szerződés megkötésének elősegítésére irányuló
					tevékenységet, amelynek során{" "}
					<strong>
						Többes Ügynök a Pénzügyi Intézmény kockázatára önállóan kötelezettséget nem vállal és szerződést
						nem köt.
					</strong>
				</p>
				<h3 className="pb-2">2. Versengő szolgáltatások:</h3>
				<ol type="a">
					<li className="pb-2">
						ingatlanon alapított jelzálogjog (ideértve az önálló zálogjogot is) fedezete mellett öt évet
						elérő vagy azt meghaladó legrövidebb futamidőre kínált hitel és pénzkölcsön, valamint az
						ingatlan pénzügyi lízing,{" "}
					</li>

					<li className="pb-2">
						ingatlanon alapított jelzálogjog (ideértve az önálló zálogjogot is) fedezete mellett öt évet meg
						nem haladó leghosszabb futamidőre kínált hitel és pénzkölcsön, valamint pénzügyi lízing, továbbá
						valamennyi, ingatlanon alapított jelzálogjog fedezete nélkül kínált hitel és pénzkölcsön,
						ideértve a fizetési számlához (bankszámlához) kapcsolódó hitelkeretet és a hitelkártyát is, vagy{" "}
					</li>

					<li className="pb-2">betét és fizetési számla (bankszámla). </li>
				</ol>
				<h3 className="pb-2">3. Ügyfél:</h3>
				<p>
					Az a jogi személy, szervezet, egyéni vállalkozó, magánszemély, aki részére a Többes Ügynök pénzügyi
					szolgáltatást közvetít. Az Ügyfélre a jelen Üzletszabályzat fogyasztókra vonatkozó rendelkezéseit
					csak abban az esetben kell alkalmazni, ha az Ügyfél a vonatkozó jogszabályok szerint fogyasztónak
					minősül.
				</p>
				<p>
					A Hpt. 6. § (1) 28 pontja alapján fogyasztó: az önálló foglalkozásán és gazdasági tevékenységén
					kívül eső célok érdekében eljáró természetes személy;
				</p>
				<h3 className="pb-2">4. Pénzügyi Intézmény:</h3>
				<p>
					Az a Magyarországon pénzügyi szolgáltatás végzésére jogosult pénzügyi intézmény (Hpt. szerinti
					hitelintézet, pénzügyi vállalkozás), amellyel a Többes Ügynök érvényes megbízási szerződést kötött
					többes ügynöki tevékenységére vonatkozóan.
				</p>
				<h3 className="pb-2">5. Közvetítői alvállalkozó:</h3>
				<p>
					A Többes Ügynökkel pénzügyi szolgáltatás közvetítése tevékenységi körében megbízási szerződést
					kötött jogi személy, egyéni cég és egyéni vállalkozó. Az MNB honlapján az I. pontban megjelölt link
					által elérhető keresést követően a Többes Ügynök részletes adatain belül a „Megbízó szerep”
					menüpontnál a Többes Ügynökkel szerződéses kapcsolatban álló Közvetítői alvállalkozók
					megtekinthetőek.
				</p>
				<h3 className="pb-2">6. Ajánlat:</h3>
				<p>A Pénzügyi Intézmény nevében kiadott nem kötelező érvényű tájékoztató ajánlat.</p>
				<h3 className="pb-2">7. Adatlap és dokumentáció:</h3>
				<p>
					A Többes Ügynök által az Ügyfél rendelkezésére bocsátott formanyomtatvány, mely tartalmazza a
					Pénzügyi Intézmény által az ügylet elbírálásához szükséges adatokat, dokumentumok felsorolását és az
					ügyfélnyilatkozatokat. Az Adatlap a jelen Üzletszabályzat elválaszthatatlan <strong>1. sz.</strong>{" "}
					mellékletét képező Közvetítői szerződés részét képezi.
				</p>
				<h3 className="pb-2">8. Közvetítői szerződés:</h3>
				<p>
					Az Ügyfél és a Többes Ügynök között létrejött szerződés, mely alapján a Többes Ügynök többes ügynöki
					feladatot lát el, és amelynek elválaszthatatlan részét képezi a jelen Üzletszabályzat.
				</p>
				<p>
					A Közvetítői szerződés mintája a jelen Üzletszabályzat elválaszthatatlan <strong>1. sz.</strong>{" "}
					melléklete.
				</p>
				<h3 className="pb-2">9. Jogszabályi rövidítések:</h3>
				<p>
					<strong>Hpt.</strong>: a hitelintézetekről és pénzügyi vállalkozásokról szóló{" "}
					<a href="https://net.jogtar.hu/jogszabaly?docid=a1300237.tv" target="_blank" rel="noreferrer">
						2013. évi CCXXXVII. törvény
					</a>{" "}
					(a továbbiakban: "Hpt")
					<br />
					<strong>Fhtv.</strong>: a fogyasztónak nyújtott hitelről szóló{" "}
					<a href="https://net.jogtar.hu/jogszabaly?docid=a0900162.tv" target="_blank" rel="noreferrer">
						2009. évi CLXII. törvény
					</a>
					<br />
					<strong>Ptk.</strong>: a Polgári Törvénykönyvről szóló{" "}
					<a href="https://net.jogtar.hu/jogszabaly?docid=a1300005.tv" target="_blank" rel="noreferrer">
						2013. évi V. törvény
					</a>
				</p>
				<h2 className="h1 mb-lg-4 mb-md-3 mb-2">IV. Általános rendelkezések</h2>
				<h3 className="pb-2">1. Az Üzletszabályzat nyilvánossága</h3>
				<p>
					Az Üzletszabályzat nyilvános, azt bárki megtekintheti és megismerheti a Többes Ügynök Ügyfelek
					számára nyitva álló helyiségében (1037 Budapest, Montevideo utca 16/B.) jelen Üzletszabályzat 7.1.
					pontjában meghatározott nyitvatartási időben, vagy a Többes Ügynök honlapján (
					<a href="https://bankmonitor.hu">www.bankmonitor.hu</a>).
				</p>
				<h3 className="pb-2">2. A Felek képviselői</h3>
				<p>
					Az Ügyfél a Többes Ügynöknek az Ügyfelek számára nyitva álló helyiségében dolgozó alkalmazottait –
					ha csak a körülményekből más nem következik - az ilyen helyen szokásos ügyletek megkötése
					tekintetében a Többes Ügynök képviselőjének tekintheti.
				</p>
				<p>
					A Többes Ügynök az üzleti kapcsolat biztonsága érdekében bármikor meggyőződhet az Ügyfél nevében
					eljáró személy(ek) képviseleti jogosultságáról, így bármikor kérheti a képviseleti jog megfelelő,
					hitelt érdemlő igazolását. Természetes személy Ügyfél esetén a Többes Ügynök jogosult a
					személyazonosság megfelelő igazolása érdekében eredeti okiratok bemutatását kérni.
				</p>
				<p>
					A Többes Ügynök jogosult az Ügyfél által hozzá bejelentett képviselő(ke)t, illetve az egy vagy több
					képviselő aláírását mindaddig érvényesnek tekinteni, amíg a képviseleti jog megszűnéséről,
					visszavonásáról vagy az új képviselő képviseleti jogáról szóló - a szükséges okiratokkal
					megerősített - írásbeli értesítés hozzá meg nem érkezett.
				</p>
				<h3 className="pb-2">3. Értesítések</h3>
				<p>A Felek az egymásnak szóló értesítéseket kötelesek írásba foglalni, illetve írásban megerősíteni.</p>
				<p>
					A Többes Ügynök az Ügyfél részére szóló iratokat (nyilatkozatokat, értesítéseket, stb.) arra a címre
					küldi meg, amelyet az Ügyfél megadott. Ilyen cím hiányában a Többes Ügynök az Ügyfél általa ismert
					címére is küldheti az iratokat.
				</p>
				<p>
					Ha a Többes Ügynök rendelkezésére semmilyen cím nem áll, az értesítés elmaradásából származó
					károkért a Többes Ügynök nem felel.
				</p>
				<p>
					A Többes Ügynök nem felel azért, ha a megadott név, cím pontatlansága, változása miatt vagy más, a
					Többes Ügynökön kívülálló okból, a kézbesítés elhúzódik vagy eredménytelen.
				</p>
				<p>
					Az Ügyfél által közölt hibás cím miatti téves postázásból adódó károk és többletköltségek az
					Ügyfelet terhelik, és a felmerülésükkor azonnal esedékesek.
				</p>
				<p>
					A Többes Ügynök az Ügyfél részére szóló iratokat – hacsak jogszabály eltérően nem rendelkezik – nem
					köteles ajánlottan vagy tértivevénnyel postára adni. Az elküldést megtörténtnek kell tekinteni, ha
					az elküldést kézjeggyel ellátott feladójegyzék, feladóvevény vagy a Többes Ügynök által e célból
					vezetett nyilvántartása igazolja.
				</p>
				<p>
					Belföldi cím esetén a postára adást követő 5., európai cím esetén a postára adást követő 10., postai
					munkanap elteltével a Többes Ügynök jogosult úgy tekintetni, hogy az írásos értesítést az Ügyfél
					megkapta, azaz a kézbesítés megtörtént.
				</p>
				<p>
					Az Ügyfél köteles 10 naptári napon belül értesíteni a Többes Ügynököt, ha valamely általa a Többes
					Ügynöktől várt értesítés nem érkezett meg. E határidő elmulasztásának következményei az Ügyfelet
					terhelik, és a Többes Ügynök nem felel a 10 naptári napot meghaladó fenti késedelemből eredő kárért.
				</p>
				<p>
					Az Ügyfél a Többes Ügynök részére szóló küldeményeket a Többes Ügynök székhelyére köteles
					megküldeni.
				</p>
				<p>
					Azokat az értesítéseket, nyilatkozatokat, amelyek érvényességéhez jogszabály írásbeli alakot nem
					rendel, a Többes Ügynök jogosult nem cégszerűen aláírva, illetve aláírással-pecséttel ellátva vagy a
					Többes Ügynök honlapján keresztül elektronikus úton is megküldeni az Ügyfélnek. Ezen értesítések
					illetve nyilatkozatok a cégszerű aláírás hiányában is érvényesnek tekintendők.
				</p>
				<p>
					A Többes Ügynök az Ügyféllel fennálló kapcsolatára és a konkrét ügyre tekintettel a telefonon,
					telefaxon, e-mailben vagy a Többes Ügynök honlapján keresztül elektronikus úton adott értesítéseket,
					megbízásokat, üzeneteket is elfogadja, ha erről az Ügyféllel kifejezetten, írásban megállapodott.
				</p>
				<p>
					A telefonon, telefaxon, e-mailben, illetve a Többes Ügynök honlapján keresztül elektronikus úton
					érkezett és a Többes Ügynök által teljesített kérelmeket minden esetben az Ügyféltől származónak
					kell tekinteni.
				</p>
				<p>
					A telefonon vagy más, nem írásbeli formában kapott közlés írásbeli visszaigazolása esetén a másik
					fél azonnal köteles jelezni a közlés és az írásbeli visszaigazolás közötti eltérést.
				</p>
				<p>
					A Többes Ügynök nem felel azért a kárért, amely a telefon, telefax, e-mail kapcsolat vagy a Többes
					Ügynök honlapján keresztül létesített elektronikus kapcsolat során előforduló tévedés, félreértés
					vagy hiba eredménye, hacsak a kár nem a Többes Ügynök hibájából ered.
				</p>
				<h3 className="pb-2">4. Együttműködés</h3>
				<p>
					A Többes Ügynök és az Ügyfél az üzleti kapcsolataikban kölcsönösen együttműködve, egymás érdekeit is
					figyelembe véve kötelesek eljárni.
				</p>
				<p>
					A Többes Ügynök a tevékenysége során mindenkor az adott helyzetben általában elvárható
					körültekintéssel és gondossággal jár el.
				</p>
				<p>
					A Többes Ügynök a közvetített szerződés futamideje alatt is az Ügyfél rendelkezésére áll az adott
					közvetített szerződéssel kapcsolatos kérdések megválaszolása és esetleges problémák megoldásának
					elősegítése érdekében.
				</p>
				<h3 className="pb-2">5. Banktitkok és üzleti titok</h3>
				<p>
					A Többes Ügynök az Ügyféllel való kapcsolata során tudomására jutott banktitoknak minősülő
					információkat a jogszabályi előírásoknak megfelelően banktitokként kezeli, és azokat az Ügyfél által
					adott írásbeli meghatalmazásban, valamint az alábbiakban megjelölt esetekben és kereteken túl csak a
					jogszabályban meghatározott személyeknek, illetve csak a jogszabályokban meghatározott esetben
					szolgáltatja ki. A Többes Ügynök felelős az általa igénybevett jogi vagy egyéb képviselő, szakértő
					és közreműködő titoktartásáért, és a részükre történő adatszolgáltatáskor erre külön felhívja a
					figyelmüket. A Többes Ügynök az üzleti kapcsolatok megszűnése után is - időbeli korlátozás nélkül -
					megőrzi a banktitkot.
				</p>
				<p>
					Az Ügyfél köteles a Többes Ügynökről tudomására jutott üzleti titkokat bizalmasan kezelni. Üzleti
					titok - minden olyan, a Többes Ügynök pénzügyi szolgáltatás közvetítői tevékenységéhez kapcsolódó -
					tény, információ, megoldás vagy adat, amelynek titokban maradásához a Többes Ügynöknek méltányolható
					érdeke fűződik. A Többes Ügynök felhívja az Ügyfél figyelmét, hogy az üzleti titok megsértése
					polgári jogi, illetve büntetőjogi következményekkel járhat.
				</p>
				<h3 className="pb-2">6. Panaszkezelés</h3>
				<ol>
					<li className="pb-2">
						Többes Ügynök a panaszok kezelésére, a panaszügyintézés módjára, valamint a panasznyilvántartás
						vezetésére vonatkozóan külön panaszkezelési szabályzattal (a továbbiakban: „Panaszkezelési
						szabályzat”) rendelkezik, mely a Többes Ügynök honlapján (bankmonitor.hu) is elérhető. Az Ügyfél
						által a Többes Ügynök pénzügyi közvetítői szolgáltatásával kapcsolatosan megtett észrevételeit,
						panaszait a Többes Ügynök a Panaszkezelési szabályzatban, a 28/2014. MNB rendeletben és a
						435/2016. Kormányrendeletben foglaltaknak megfelelően fogadja, nyilvántartja, kivizsgálja és
						megválaszolja, továbbá a panasz nyilvántartásához szükséges adatokat kezeli.
					</li>

					<li className="pb-2">
						A Többes Ügynök a panasz kivizsgálásához, nyilvántartásához és megválaszolásához szükséges, a
						Panaszkezelési szabályzatban megjelölt adatokat kezeli és nyilvántartja.
					</li>

					<li className="pb-2">
						A Többes Ügynök az írásbeli panasszal kapcsolatos, indokolással ellátott álláspontját a panasz
						közlését követő harminc napon belül megküldi az Ügyfélnek.
					</li>

					<li className="pb-2">
						A panasz elutasítása esetén a Többes Ügynök válaszában tájékoztatja az Ügyfelet arról, hogy a
						<a href="https://www.mnb.hu/web/fooldal" target="_blank" rel="noreferrer">
							Magyar Nemzeti Bank
						</a>
						ról szóló 2013. évi CXXXIX. törvény szerinti fogyasztóvédelmi rendelkezések megsértése esetén az
						MNB előtt a vonatkozó formanyomtatvány kitöltésével fogyasztóvédelmi eljárást kezdeményezhet,
						vagy a szerződés létrejöttével, érvényességével, joghatásaival és megszűnésével, továbbá a
						szerződésszegéssel és annak joghatásaival kapcsolatos jogvita esetén bírósághoz fordulhat, vagy
						a Pénzügyi Békéltető Testület (cím: 1013 Budapest, Krisztina krt. 39.; levélcím: H-1525 Budapest
						Pf.:172.; telefonszám: +36-80-203-776; email cím: ugyfelszolgalat@mnb.hu) eljárását
						kezdeményezheti. A panaszra adott válasz külön is tartalmazza a Pénzügyi Békéltető Testület
						levelezési címét.
					</li>

					<li className="pb-2">
						Az Ügyfél a Többes Ügynök által közvetített pénzügyi szolgáltatással kapcsolatos észrevételeit,
						panaszait a közvetített pénzügyi szolgáltatást nyújtó Pénzügyi Intézménynél teheti meg.
						Amennyiben a Többes Ügynökhöz érkezik ilyen tartalmú panasz, úgy azt a Többes Ügynök 3
						munkanapon belül továbbítja a Pénzügyi Intézmény részére.
					</li>
				</ol>
				<h2 className="h1 mb-lg-4 mb-md-3 mb-2">V. Ügyfelek tájékoztatása</h2>
				<h3 className="pb-2">
					1. A Többes Ügynök valamennyi pénzügyi szolgáltatás közvetítését megelőző általános tájékoztatási
					kötelezettsége
				</h3>
				<p>
					A Többes Ügynök az <strong>53/2016. NGM</strong> rendeletnek megfelelően, a jelen Üzletszabályzat
					elválaszthatatlan
					<strong> 2. sz.</strong> melléklete szerinti tartalommal a pénzügyi szolgáltatás közvetítését
					megelőzően a pénzügyi szolgáltatást igénybe venni szándékozó fogyasztó részére írásban vagy más
					tartós adathordozón igazolható módon egyértelmű tájékoztatást ad:
				</p>
				<ol type="a">
					<li className="pb-2">
						a cég nevéről, székhelyéről, levelezési címéről, felügyeleti hatóságának megjelöléséről,{" "}
					</li>

					<li className="pb-2">
						a felügyeleti nyilvántartásról, amelyben szerepel, és annak módjáról, ahogyan nyilvántartását
						ellenőrizni lehet,
					</li>

					<li className="pb-2">
						arról, hogy a tevékenysége során okozott kárért a fogyasztó felé ki áll helyt,{" "}
					</li>

					<li className="pb-2">
						arról, hogy többes ügynökként a pénzügyi intézmény megbízásából jár el a pénzügyi intézmény vagy
						a pénzügyi intézmények nevének feltüntetésével,
					</li>

					<li className="pb-2">arról, hogy nyújt-e hiteltanácsadást, </li>

					<li className="pb-2">
						arról, hogy a pénzügyi szolgáltatás közvetítéséért közvetítői díjat kizárólag a megbízótól
						fogadhat el,
					</li>

					<li className="pb-2">
						többes ügynökként arról, hogy a megbízó pénzügyi intézménytől kap-e közvetítői díjat, és{" "}
					</li>
					<ol type="a">
						<li className="pb-2">ha ismert, annak összegéről,</li>

						<li className="pb-2">
							ha nem ismert a tájékoztatás időpontjában, jelzáloghitel közvetítése esetén arról, hogy a
							tényleges díj a személyre szóló tájékoztatóban fog szerepelni,
						</li>
					</ol>

					<li className="pb-2">
						adott esetben a közvetítővel kapcsolatos panasz kezeléséről, valamint a Pénzügyi Békéltető
						Testület eljárásának igénybevételére vonatkozó lehetőségről, valamint
					</li>

					<li className="pb-2">
						arról, hogy a pénzügyi szolgáltatás közvetítését igénybe vevő fogyasztó számára más - pénzügyi
						szolgáltatás közvetítésének nem minősülő - szolgáltatása ellenértékeként díjat számít-e fel.
					</li>
				</ol>
				<p>
					Amennyiben a Többes Ügynök a Pénzügyi Intézménytől díjazásban részesül, a fogyasztó kérésére
					tájékoztatást ad arról, hogy mennyiben tér el egymástól a fogyasztónak kínált hiteleket nyújtó
					Pénzügyi Intézmények által fizetendő díjazás mértéke. A Többes Ügynök köteles a fogyasztót
					tájékoztatni arról, hogy jogosult ezen tájékoztatást kérni.
				</p>
				<p>
					A Többes Ügynök az adott pénzügyi szolgáltatásra vonatkozó ajánlat kiküldését, illetőleg az adott
					pénzügyi szolgáltatásra vonatkozó szerződés megkötését megelőzően tájékoztatja az Ügyfelet minden
					olyan adatról, körülményről és információról, mely a szerződés megkötése és teljesítése esetén
					lényeges lehet és amelyek alapján az Ügyfél felmérheti, hogy az igénybe venni tervezett pénzügyi
					szolgáltatás (pl. hitel felvétele) és – ha kapcsolódó szolgáltatás nyújtására is sor kerül – a
					kapcsolódó szolgáltatás megfelel-e az igényeinek és a pénzügyi teljesítőképességének.
				</p>
				<h3 className="pb-2">
					2. A fogyasztónak nyújtott hitelre vonatkozó kereskedelmi kommunikáció szabályai
				</h3>
				<p>
					A Többes Ügynök az Fhtv. 4. § rendelkezéseinek megfelelően a hitelre vonatkozó kereskedelmi
					kommunikáció során köteles kerülni minden olyan megfogalmazást, amely a hitel elérhetősége vagy
					költsége tekintetében téves várakozásokat kelthet a fogyasztóban. A kereskedelmi kommunikáció során
					az információnak könnyen olvashatónak vagy jól hallhatónak kell lennie. A hitelre vonatkozó
					kereskedelmi kommunikációban a teljes hiteldíj mutató értékét feltűnően, a rövidítés
					feltüntetésével, egy tizedesjegy pontossággal minden esetben meg kell adni.
				</p>
				<p>
					Ha a hitelre vonatkozó kereskedelmi kommunikáció a teljes hiteldíj mutató értékén kívül hitelkamatot
					vagy bármilyen más ellenszolgáltatásra - ideértve a díjat, jutalékot, költséget - vonatkozó
					számadatot megjelöl, a kereskedelmi kommunikációban egyértelműen, tömören és feltűnően,
					reprezentatív példával bemutatva meg kell adni a következő adatokat is:
				</p>
				<ol type="a">
					<li className="pb-2">
						a hitelkamat mértéke és típusa (rögzített hitelkamat, változó hitelkamat vagy mindkettő),{" "}
					</li>

					<li className="pb-2">a hitel teljes díjában foglalt díj, jutalék, költség és adó, </li>

					<li className="pb-2">a hitel teljes összege, </li>

					<li className="pb-2">a hitel futamideje, </li>

					<li className="pb-2">a teljes hiteldíj mutató, </li>

					<li className="pb-2">
						termék értékesítéséhez vagy szolgáltatás nyújtásához kapcsolódó halasztott fizetés formájában
						nyújtott hitel esetén a termék vagy szolgáltatás készpénzára és az önrész, valamint
					</li>

					<li className="pb-2">a fogyasztó által fizetendő teljes összeg és a törlesztőrészlet összege. </li>
				</ol>
				<p>
					Ha a jelzáloghitelre vonatkozó kereskedelmi kommunikáció a teljes hiteldíj mutató értékén kívül
					hitelkamatot vagy bármilyen más ellenszolgáltatásra - ideértve a díjat, jutalékot, költséget -
					vonatkozó számadatot megjelöl - a fenti bekezdés a)-e) és g) pontján túl -, a kereskedelmi
					kommunikációban egyértelműen, tömören és feltűnően meg kell adni a következőket is:
				</p>
				<ol type="a">
					<li className="pb-2">a hitelező, a hitelközvetítő vagy a közvetítői alvállalkozó neve, </li>

					<li className="pb-2">
						tájékoztatás arra vonatkozóan, hogy a hitel fedezete ingatlanra bejegyzett jelzálogjog,{" "}
					</li>

					<li className="pb-2">a törlesztőrészletek száma, valamint </li>

					<li className="pb-2">
						devizaalapú hitel esetén figyelmeztetés arra vonatkozóan, hogy az árfolyam változása
						befolyásolhatja a fogyasztó által fizetendő összeget.
					</li>
				</ol>
				<p>
					A kereskedelmi kommunikációban alkalmazott reprezentatív példát a tájékoztatásban is következetesen
					alkalmazni kell.
				</p>
				<p>
					Ha a hitelhez kapcsolódó szolgáltatás (például biztosítás) igénybevétele a hitelszerződés
					megkötéséhez vagy a hitelező ajánlata szerinti megkötéséhez szükséges, és a hitelhez kapcsolódó
					szolgáltatás ellenszolgáltatása nem ismert, a hitelre vonatkozó kereskedelmi kommunikációban a
					hitelhez kapcsolódó szolgáltatásra vonatkozó szerződés megkötésének kötelezettségét is jelezni kell
					egyértelműen, tömören és feltűnően, a teljes hiteldíj mutatóval együtt.
				</p>
				<p>
					A hitelközvetítő a hitelre vonatkozó kereskedelmi kommunikációban köteles feltüntetni, hogy kinek a
					képviseletében jár el.
				</p>
				<h3 className="pb-2">3. Fogyasztói hitelszerződés megkötését megelőző tájékoztatás</h3>
				<p>
					A Többes Ügynök az Fhtv. rendelkezéseinek megfelelően, az abban meghatározott fogyasztói
					hitelszerződés megkötését megelőzően a fogyasztó részére köteles olyan felvilágosítást adni,
					amelynek alapján a fogyasztó felmérheti, hogy az igénybe venni tervezett hitel és - ha kapcsolódó
					szolgáltatás nyújtására is sor kerül - a kapcsolódó szolgáltatás megfelel-e az igényeinek és a
					pénzügyi teljesítőképességének. Ennek során a hitelező és adott esetben a hitelközvetítő vagy
					közvetítői alvállalkozó a fogyasztó rendelkezésére bocsátja a különböző ajánlatok
					összehasonlításához szükséges információkat annak érdekében, hogy a fogyasztó megalapozott döntést
					hozhasson a hitelszerződés esetleges megkötése tekintetében.
				</p>
				<p>
					A felvilágosításnak mindenekelőtt ki kell terjednie az ajánlott termékek legfontosabb jellemzőire, a
					fogyasztó pénzügyi helyzetére gyakorolt hatására és a fizetés elmulasztásának következményeire, így
					különösen a késedelmi kamatra, a hitel felmondására és a biztosítékok érvényesítésére.
				</p>
				<p>
					A felvilágosítást tömör és informatív módon úgy kell nyújtani, hogy az a fogyasztó számára érthető
					és áttekinthető legyen, reprezentatív példákkal ábrázolt módon mutassa be, hogy a hitelfelvétel
					törlesztése a jövedelmi viszonyaihoz, illetve annak esetleges változásához képest milyen terhet
					jelent, és hogy a törlesztés során milyen további kockázatokkal kell számolnia, ideértve a kamat- és
					az árfolyamkockázatot is.
				</p>
				<p>
					A felvilágosítás során egyértelmű általános tájékoztatást kell nyújtani a hitelfelvétel
					folyamatáról, továbbá a{" "}
					<a href="https://www.mnb.hu/web/fooldal" target="_blank" rel="noreferrer">
						Magyar Nemzeti Bank
					</a>{" "}
					fogyasztóvédelmi hatósági jogköréről és a Pénzügyi Békéltető Testületnek a{" "}
					<a href="https://www.mnb.hu/web/fooldal" target="_blank" rel="noreferrer">
						Magyar Nemzeti Bank
					</a>
					ról szóló törvény szerinti pénzügyi fogyasztói jogvita bírósági eljáráson kívüli rendezésében
					betöltött szerepéről.
				</p>
				<p>Ha kapcsolódó szolgáltatás nyújtására is sor kerül, a felvilágosításnak ki kell terjednie </p>
				<ol type="a">
					<li className="pb-2">
						arra, hogy az összekapcsolt szolgáltatások viszonya járulékos vagy önálló, valamint{" "}
					</li>

					<li className="pb-2">az egyes szerződések felmondásának körülményeire is. </li>
				</ol>
				<p>
					A fogyasztónak nyújtott tájékoztatást a Többes Ügynök az Fhtv. rendelkezéseinek, illetve az 56/2014.
					NGM-rendeletnek, valamint a 3/2016. NGM-rendeletnek megfelelően köteles nyújtani. Ennek megfelelően
					a jelen Üzletszabályzat elválaszthatatlan részét és mellékleteit képezi
				</p>
				<ol type="a">
					<li className="pb-2">
						<strong>3. sz.</strong> mellékletként a fogyasztói hitelszerződések összehasonlítására vonatkozó
						általános tájékoztatás mintája (Fhtv. 1. sz. melléklete szerint),
					</li>

					<li className="pb-2">
						<strong>4. sz.</strong> mellékletként a hitelszerződések és pénzügyi lízingszerződések
						törlesztőrészleteinek változására vonatkozó melléklet (56/2014. NGM-rendelet 1 .sz. melléklete
						szerint),
					</li>

					<li className="pb-2">
						<strong>5. sz.</strong> mellékletként a fogyasztónak nyújtott jelzáloghitelre vonatkozó
						általános tájékoztatás mintája (3/2016. NGM-rendelet 1. sz. melléklete szerint),
					</li>

					<li className="pb-2">
						<strong>6. sz.</strong> mellékletként a fogyasztónak nyújtott jelzáloghitelre vonatkozó
						személyre szóló tájékoztatás mintája (3/2016. NGM-rendelet 2. sz. melléklete szerint).
					</li>
				</ol>
				<p>
					Jelzáloghitel és ingatlanra vonatkozó pénzügyi lízing igénylése esetén a hitelezőre nézve kötelező
					ajánlat megtételekor a szerződés tervezetét a fogyasztó kérése nélkül is legalább három nappal a
					tervezett szerződéskötést megelőzően a fogyasztó rendelkezésére kell bocsátani. A fogyasztó a három
					nap leteltéig az ajánlatot nem fogadhatja el. A hitelező ajánlati kötöttsége a szerződéstervezet
					fogyasztó részére történő rendelkezésre bocsátásától számított tizenöt napig áll fenn. A szerződések
					elektronikus úton nem köthetők meg, ez azonban nem akadálya annak, hogy a tájékoztatási
					kötelezettség teljesítése és annak igazolása, valamint a szerződés tervezetének rendelkezésre
					bocsátása tekintetében a felek az elektronikus utat vegyék igénybe, ha annak feltételei fennállnak.
				</p>
				<p>
					Az 56/2014. NGM rendelet 4. § (29 bekezdésének megfelelően a Többes Ügynök a fogyasztó
					lehetőségeinek felmérése érdekében a jövedelemarányos törlesztőrészlet és a hitelfedezeti arányok
					szabályozásáról szóló 32/2014. (IX. 10.) MNB rendelet hatálya alatt álló hitelszerződés ajánlása
					esetén az 56/2014. NGM rendelet 4. § (1) bekezdésének megfelelő – az igényelhető hitel lehetséges
					összegére, a kamatozás módjára (fix kamatozású, referencia-kamatlábhoz kötött, vagy
					kamatperiódusokban rögzített), a kamat módosításának lehetőségére, a reprezentatívnak tekinthető
					teljes hiteldíj mutatóra, a törlesztőrészletek összegére és a törlesztés gyakoriságára, valamint a
					hitel választható futamidejére vonatkozó – tájékoztatást megelőzően szóban vagy elektronikus úton
					tájékoztatást ad a 32/2014. (IX. 10.) MNB rendelet irányadó főbb követelményeiről, így különösen a
					jövedelemarányos törlesztőrészlet mutatóról, a havi nettó jövedelem igazolásának módjáról, a havi
					adósságszolgálat számításának módjáról, ingatlanra alapított jelzálogjog fedezete mellett vagy
					gépjármű vásárlására nyújtandó hitelnél a kitettség értékére vonatkozó előírásról.
				</p>
				<h2 className="h1 mb-lg-4 mb-md-3 mb-2">VI. Közvetítői szerződés</h2>
				<p>
					Az Ügyfél és a Többes Ügynök közötti – jelen Üzletszabályzat <strong>1. sz.</strong> mellékletét
					képező szerződésminta alapján létrejövő – közvetítői szerződés célja, hogy a Többes Ügynök:
				</p>
				<ul>
					<li className="pb-2">
						a pénzügyi szolgáltatás közvetítését megelőzően az Ügyfél tájékoztatása alapján felmérje az
						Ügyfél igényeit és szükségleteit, valamint azokat az indokokat, amelyek a többes ügynöki
						tevékenységgel összefüggésében adott tanácsot alátámasztják,
					</li>

					<li className="pb-2">
						az Ügyfél részére kielégítő mennyiségű, de - ha a piacon hozzáférhető - legalább három Pénzügyi
						Intézmény egymással versengő pénzügyi szolgáltatásnak minősülő ajánlatát elemezze és átadja,
					</li>

					<li className="pb-2">
						konzultációval és a különböző ajánlatok összehasonlításához szükséges információknak az Ügyfél
						rendelkezésére bocsátásával segítse az Ügyfelet a számára kedvező és elérhető pénzügyi
						szolgáltatás kiválasztásában,
					</li>

					<li className="pb-2">
						az Ügyfél által átadott és kitöltött Adatlapot és dokumentációt a Pénzügyi Intézmény részére
						továbbítsa,
					</li>

					<li className="pb-2">
						a pénzügyi szolgáltatási szerződés megkötésének elősegítése és megvalósítása érdekében az
						ügylettel kapcsolatban folyamatosan kapcsolatot tartson az Ügyfél által választott Pénzügyi
						Intézménnyel és közreműködésével segítse elő az ügylet megvalósulását,
					</li>

					<li className="pb-2">
						a megvalósult ügylethez kapcsolódó dokumentumokat, információkat továbbítsa az Ügyfél és a
						Pénzügyi Intézmény részére és a szerződés megkötésének folyamatát kövesse nyomon.
					</li>
				</ul>
				<p>
					A jelen Üzletszabályzat rendelkezései annak kihirdetésének, illetőleg közzétételének napját követő
					napon lépnek hatályba és határozatlan időre szólnak. A Többes Ügynök és az Ügyfél között a jelen
					Üzletszabályzat a Közvetítői szerződés létrejöttével válik a Közvetítői szerződés részévé.
				</p>
				<h2 className="h1 mb-lg-4 mb-md-3 mb-2">VII. A Többes Ügynök díjazása </h2>
				<p>
					A Többes Ügynök többes ügynökként elvégzett pénzügyi szolgáltatás közvetítéséért{" "}
					<strong>
						közvetítői díjra az Ügyféltől nem jogosult, közvetítői díjat kizárólag a megbízó Pénzügyi
						Intézménytől fogadhat el.
					</strong>{" "}
					E rendelkezés nem érinti a Többes Ügynök azon jogosultságát, hogy a pénzügyi szolgáltatás
					közvetítését igénybe vevő Ügyfele számára más - a pénzügyi szolgáltatás közvetítésének nem minősülő
					- szolgáltatása ellenértékeként díjat számítson fel [Hpt. 69. § (3)].
				</p>
				<p>
					<strong>
						A Többes Ügynök pénzügyi szolgáltatás közvetítésének nem minősülő szolgáltatásért ellenértéket
						nem számít fel.
					</strong>
				</p>
				<p>
					A Többes Ügynök az Ügyfél kérésére tájékoztatást ad arról, hogy mennyiben tér el egymástól az
					Ügyfélnek kínált hiteleket nyújtó pénzügyi intézmények által fizetendő díjazás mértéke, továbbá
					tájékoztatja az Ügyfelet arról, hogy az Ügyfél jogosult ilyen információt kérni.
				</p>
				<h2 className="h1 mb-lg-4 mb-md-3 mb-2">VIII. A Többes Ügynök felelőssége</h2>
				<p>A Többes Ügynök mint többes ügynök e tevékenysége során okozott kárért maga felel. </p>

				<p>
					A Többes Ügynök mint többes ügynök felelős a téves tanácsadásért, az iratok és a nyilatkozatok
					késedelmes továbbításáért.
				</p>

				<p>
					A Többes Ügynök pénzügyi szolgáltatás közvetítésével kapcsolatos tevékenysége során mindenkor a Hpt.
					többes ügynökre vonatkozó szabályai szerint jár el.
				</p>

				<p>
					A Többes Ügynök ügynöki tevékenységéhez az MNB felé bejelentett közvetítői alvállalkozót a Hpt.
					rendelkezéseinek megfelelően vehet igénybe. A Többes Ügynök az általa az e tevékenységre igénybe
					vett, vele megbízási, illetve munkavégzésre irányuló egyéb jogviszonyban álló személy által e
					tevékenysége során okozott kárért – így az általa ilyen módon igénybe vett közvetítői alvállalkozó
					által okozott kárért is – felel [Hpt. 69. § (1)].
				</p>

				<p>
					A Többes Ügynök nem felel a vis maior (elháríthatatlan okból), a jogszabályból vagy hatósági
					rendelkezésből, vagy a Többes Ügynök működésének harmadik személy általi megzavarásából eredő
					Ügyfelet ért károkért.
				</p>

				<p>
					A Többes Ügynök nem felelős azokért a károkért, amelyek abból keletkeznek, hogy az Ügyfél a
					közvetített ügylet kapcsán használt jogi, pénzügyi és egyéb speciális szakismeretet igénylő
					szakkifejezéseket a Többes Ügynök által a részére adott felvilágosítás ellenére nem megfelelően
					értelmezte, értette.
				</p>

				<p>
					A Többes Ügynök tevékenységéből eredő károk biztosítására mindenkor káreseményenként legalább
					460.000,- EUR, illetve évente együttesen legalább 750.000,- EUR összegű felelősségbiztosítása
					rendelkezésre áll. A Többes Ügynök szakmai tevékenysége során okozott károkért a{" "}
					<a href="https://www.generali.hu/" target="_blank" rel="noreferrer">
						Generali Biztosító Zrt.
					</a>{" "}
					mint a Többes Ügynök felelősségbiztosítója áll helyt (kötvényszám: 95616333812247900).
				</p>

				<p>
					A Többes Ügynök tevékenysége kizárólag az Ügyfél jelen Üzletszabályzatban foglalt tájékoztatására és
					a Közvetítői szerződésben meghatározott feladatok teljesítésére korlátozódik, így a Többes Ügynök
					tevékenysége nem minősül eredménykötelesnek. A Többes Ügynök ezért nem szavatolja az Ügyfél felé a
					Többes Ügynök által közvetített pénzügyi szolgáltatásnak a Pénzügyi Intézmény részéről történő
					pozitív elbírálását, így különösen, de nem kizárólagosan az igényelt hitel (kölcsön) tényleges
					folyósítását sem.
				</p>

				<p>
					Ügyfél tudomásul veszi, hogy a Pénzügyi Intézménynek jogában áll az Ügyfél igényléséhez kapcsolódóan
					hiánypótlásként további dokumentumokat, adatokat bekérni, illetőleg az Ügyfél adott pénzügyi
					szolgáltatásra irányuló igényét indoklás nélkül elutasítani, amelyért a Többes Ügynököt semmilyen
					felelősség nem terheli.
				</p>

				<p>
					A Többes Ügynököt nem terheli továbbá felelősség a Pénzügyi Intézmény által esetlegesen kért további
					adatszolgáltatás kapcsán az Ügyfél részéről történő késedelmes teljesítésért, az ebből adódóan az
					Ügyfelet ért károkért. Többes Ügynök nem felel továbbá a Pénzügyi Intézmény ügyintézésének
					időtartamáért, továbbá bármely árfolyam-különbözetből eredő károkért.
				</p>
				<h2 className="h1 mb-lg-4 mb-md-3 mb-2">IX. A Pénzügyi Intézmény felelőssége</h2>
				<p>
					A Többes Ügynököt megbízó Pénzügyi Intézmény felel azért, hogy a Többes Ügynökkel kötött megbízási
					szerződés pontosan, egyértelműen meghatározza a Többes Ügynök mint közvetítő által ellátandó
					feladatokat, az Ügyfelek tájékoztatására vonatkozó követelményeket, továbbá azért, hogy minden, a
					Többes Ügynökkel kötött megbízási szerződés megfelelő teljesítéséhez szükséges információt a Többes
					Ügynök rendelkezésére bocsát.
				</p>
				<h2 className="h1 mb-lg-4 mb-md-3 mb-2">X. Az Ügyfél felelőssége</h2>
				<p>
					Az Ügyfél felel a Pénzügyi Intézmény részére elbírálás céljára megadott, a Pénzügyi Intézmény és az
					Ügyfél között megkötendő pénzügyi szolgáltatási szerződésre vonatkozó, a Pénzügyi Intézmény által
					megkövetelt és az ügylet elbírálásához elengedhetetlen adatlap és dokumentáció, okmányok, másolatok
					és egyéb nyilatkozatok teljességéért, azok tartalmának valódiságáért valamint helyességéért és
					időbeni rendelkezésre bocsátásáért.
				</p>

				<p>
					A Többes Ügynök nem felelős azokért a károkért, amelyek abból keletkeznek, hogy az előző bekezdésben
					felsoroltakat az Ügyfél hiányosan vagy nem a valóságnak megfelelő tartalommal vagy késedelmesen adja
					át, illetve közli a Pénzügyi Intézményhez történő továbbításra.
				</p>
				<h2 className="h1 mb-lg-4 mb-md-3 mb-2">XI. A Többes Ügynök kötelezettségei</h2>

				<p>
					A Többes Ügynök köteles a jelen Üzletszabályzat V. pontjában foglaltaknak megfelelő egyértelmű
					tájékoztatást az Ügyfélnek átadni.
				</p>

				<p>
					A Többes Ügynök a pénzügyi szolgáltatási szerződés megkötésének elősegítése során a fogyasztónak
					kielégítő mennyiségű, de - ha a piacon hozzáférhető - legalább három szolgáltató versengő
					szolgáltatásnak minősülő ajánlatát elemzi és igazolható módon írásban vagy más tartós adathordozón
					átadja.
				</p>

				<p>
					Ha a Többes Ügynök kizárólag kettő versengő szolgáltatást közvetít, akkor kettő ajánlatot elemez és
					ad át a fogyasztónak.
				</p>

				<p>
					A pénzügyi szolgáltatás közvetítését megelőzően a Többes Ügynök a fogyasztó tájékoztatása alapján
					felméri a fogyasztó igényeit és szükségleteit, valamint azokat az indokokat, amelyek a Többes Ügynök
					által e tevékenységével összefüggésben adott tanácsot alátámasztják.
				</p>

				<p>
					A Többes Ügynök a tanácsadás során az Ügyfélnek a Pénzügyi Intézményre, a közvetített szerződés
					feltételeire vonatkozó kérdéseit megválaszolja, kétség esetében haladéktalanul, de legkésőbb 2
					munkanapon belül továbbítja a felmerült kérdést a Pénzügyi Intézménynek, a válasz megérkezését
					követően pedig közli az Ügyféllel.
				</p>

				<p>
					A Többes Ügynök az Ügyfél által kiválasztott Pénzügyi Intézmény(ek) részére elbírálás céljára
					megküldi az adott Pénzügyi Intézmény és az Ügyfél között megkötendő pénzügyi szolgáltatási
					szerződésre vonatkozó adatlapot és dokumentációt, továbbá a Pénzügyi Intézmény által megkövetelt, az
					ügylet elbírálásához elengedhetetlen okmányok másolatait, és egyéb nyilatkozatokat. Az ügylet
					Pénzügyi Intézmény általi elbírálására a vonatkozó jogszabályok és az adott Pénzügyi Intézmény
					általános szerződési feltételei irányadóak.
				</p>

				<p>
					A Többes Ügynök a Hpt. alapján az Ügyféllel kötött közvetítői szerződésről és a közvetített pénzügyi
					szolgáltatási szerződésről köteles nyilvántartást vezetni.
				</p>

				<p>
					A Többes Ügynök kijelenti, hogy tevékenységéhez az MNB felé bejelentett közvetítői alvállalkozót a
					Hpt. rendelkezéseinek megfelelően vehet igénybe, melynek eljárásáért a vonatkozó jogszabályi
					rendelkezések és a közvetítői alvállalkozó szerződés szerint tartozik felelősséggel.
				</p>
				<h2 className="h1 mb-lg-4 mb-md-3 mb-2">XII. Pénzkezelés</h2>
				<p>
					A Többes Ügynök közvetítői tevékenysége során sem az Ügyfél nevében a megbízó Pénzügyi Intézménytől
					az Ügyfelet megillető pénzt nem vesz át, sem az Ügyfél által fizetendő, a megbízó Pénzügyi
					Intézményt megillető pénzösszegeket nem vesz át.
				</p>
				<h2 className="h1 mb-lg-4 mb-md-3 mb-2">XIII. Az Ügyfél kötelezettségei</h2>
				<p>
					Az Ügyfél késedelem nélkül köteles a valóságnak megfelelően tájékoztatni a Többes Ügynököt annak
					közvetítői tevékenysége szempontjából jelentős körülményekről, tényekről és adatokról, különösen, de
					nem kizárólagosan az Ügyfél azonosításához szükséges adatokról, illetve azok változásáról.
				</p>

				<p>
					Az Ügyfél köteles az Ügyfél, illetőleg az Ügyfél képviselőjének azonosításához szükséges adatokat és
					ezeket igazoló okiratokat a Többes Ügynök részére átadni a Hpt, illetőleg a pénzmosás és a
					terrorizmus finanszírozásának megelőzéséről és megakadályozásáról szóló jogszabályok
					rendelkezéseinek megfelelően.
				</p>

				<p>
					Ezen tájékoztatás, illetőleg adatszolgáltatás elmaradásából, késedelméből, valamint a hibás,
					félreérthető, illetőleg félrevezető vagy valótlan adatokat tartalmazó tájékoztatás adásából származó
					károk és többletköltségek az Ügyfelet terhelik, azokért a Többes Ügynök nem felel.
				</p>

				<p>
					Az Ügyfél a Többes Ügynök által közvetített szerződés futamideje alatt – ha az előírja - a
					számviteli törvény szerinti éves beszámolójának (mérleg, eredmény-kimutatás, kiegészítő melléklet,
					könyvvizsgálói jelentés, záradék) egy másolati példányát minden év június 15. napjáig köteles a
					Többes Ügynöknek megküldeni, amit a Többes Ügynök haladéktalanul továbbít a Pénzügyi Intézmény
					részére.
				</p>
				<h2 className="h1 mb-lg-4 mb-md-3 mb-2">XIV. Adatkezelés, adatátadás, ügyfélszerződés nyilvántartás</h2>
				<p>
					A Többes Ügynök köteles a pénzügyi szolgáltatási szerződéssel összefüggésben tudomására jutott
					valamennyi banktitoknak minősülő adatot és információt megőrizni, illetőleg azokat kizárólag a Hpt.
					banktitokra vonatkozó rendelkezéseinek megfelelően adhatja ki harmadik személynek. A Többes Ügynök a
					közvetítői tevékenysége során tudomására jutó banktitoknak, illetve üzleti titoknak minősülő
					adatokat a Hpt. VIII. fejezetében foglaltak szerint köteles kezelni. A Többes Ügynök csak az Ügyfél
					megfelelő azonosítását követően ad tájékoztatást a közvetített szerződéssel kapcsolatos,
					banktitoknak minősülő információkról.
				</p>

				<p>
					Tekintettel arra, hogy a Többes Ügynök a Hpt. 69. § (5) bekezdés alapján az Ügyféllel kötött
					közvetítői szerződésről és a közvetített pénzügyi szolgáltatási szerződésről köteles nyilvántartást
					vezetni, ezért az Ügyfél hozzájárul, hogy az alábbi adatokat a Többes Ügynök legalább három évig
					tárolja: közvetített szerződés feleinek nevét, a szerződéskötés idejét, tárgyát, lényeges
					feltételeit. Ez a kötelezettség nem érinti a számviteli bizonylat megőrzésére vonatkozó
					rendelkezéseket.
				</p>

				<p>
					A Többes Ügynök adatkezelésére egyebekben a jelen Üzletszabályzat <strong>7. sz.</strong>{" "}
					elválaszthatatlan részét képező Adatvédelmi szabályzata irányadó, mely a Többes Ügynök honlapján
					(bankmonitor.hu) folyamatosan elérhető a {/* biome-ignore lint/a11y/noBlankTarget: in-page link */}
					<a href={Config.getBankmonitorUrl("/adatvedelem")} target="_blank">
						{Config.getBankmonitorUrl("/adatvedelem/")}
					</a>{" "}
					linkre kattintva.
				</p>
				<h2 className="h1 mb-lg-4 mb-md-3 mb-2">XV. Záró rendelkezések</h2>
				<p>
					A jelen Üzletszabályzatban nem szabályozott kérdésekben a Hpt., a{" "}
					<a href="https://net.jogtar.hu/jogszabaly?docid=a1300005.tv" target="_blank" rel="noreferrer">
						Magyarország Polgári Törvénykönyvéről
					</a>{" "}
					szóló mindenkori törvény, valamint az egyéb magyar jogszabályok rendelkezései az irányadók.
				</p>

				<p>
					A Felek között bármilyen felmerülő vita esetén a Felek kölcsönösen megegyeznek abban, hogy
					tárgyalásokat kezdenek a békés rendezés érdekében. Abban az esetben, ha a Felek nem tudnak írásos
					megegyezésre jutni, és az Ügyfél nem minősül fogyasztónak a magyar jogszabályok szerint, Felek a
					Budai Központi Kerületi Bíróság, illetőleg a Székesfehérvári Törvényszék kizárólagos illetékességét
					kötik ki.
				</p>

				<p>
					<br />
					<i>Kelt: Budapesten, 2017. március 21. napján </i>
				</p>

				<p>
					<u>Mellékletek:</u>
				</p>
				<ol>
					<li className="pb-2">
						<a href="/wp-content/uploads/2019/05/14132043/1._sz._melleklet_Kozvetitoi_szerzodes_BM_Partner_Minta_20190510.docx">
							Közvetítői szerződés – Minta
						</a>
					</li>
					<li className="pb-2">
						<a href="/wp-content/uploads/2017/04/03142647/2.-sz-melleklet_tajakoztatas_53_2016-NGM_MINTA_20170321.pdf">
							Valamennyi pénzügyi szolgáltatás közvetítését megelőző általános tájékoztatás
							<strong> (</strong>53/2016. NGM rendelet szerint) – Minta
						</a>
					</li>
					<li className="pb-2">
						<a href="/wp-content/uploads/2017/04/03142648/3.-sz.-mell%C3%A9klet_Fhtv_1sz_20170321.pdf">
							A fogyasztói hitelszerződések összehasonlítására vonatkozó általános tájékoztatás mintája
							(Fhtv. 1. sz. melléklete szerint)
						</a>
					</li>
					<li className="pb-2">
						<a href="/wp-content/uploads/2017/04/03142649/4.-sz.-mell%C3%A9klet_56_2014_NGM_20170321.pdf">
							A hitelszerződések és pénzügyi lízingszerződések törlesztőrészleteinek változására vonatkozó
							melléklet (56/2014. NGM-rendelet 1. sz. melléklete szerint)
						</a>
					</li>
					<li className="pb-2">
						<a href="/wp-content/uploads/2017/04/03142649/5.-sz.-Mell%C3%A9klet_2016_NGM_1sz-mell_20170321.pdf">
							A fogyasztónak nyújtott jelzáloghitelre vonatkozó általános tájékoztatás mintája (3/2016.
							NGM-rendelet 1. sz. melléklete szerint)
						</a>
					</li>
					<li className="pb-2">
						<a href="/wp-content/uploads/2017/04/03142646/6.-sz.-mell%C3%A9klet_2016_NGM_2sz-melleklet_20170321.pdf">
							A fogyasztónak nyújtott jelzáloghitelre vonatkozó személyre szóló tájékoztatás mintája
							(3/2016. NGM-rendelet 2. sz. melléklete szerint)
						</a>
					</li>
					<li className="pb-2">
						<a href="/adatvedelem/?link_type=landing-link">Adatvédelmi szabályzat</a>
					</li>
				</ol>
				<p>
					<strong>
						Korábbi, 2013. május 15-től hatályos Üzletszabályzatunk{" "}
						<a href="/wp-content/uploads/2017/01/17152250/%C3%9Czletszab%C3%A1lyzat_20130515.pdf">
							itt tekinthető
						</a>{" "}
						meg.
						<br />
						Korábbi, 2016. december 12-től hatályos Üzletszabályzatunk{" "}
						<a href="/wp-content/uploads/2017/04/03135213/Uzletszabalyzat_20161221.pdf">itt tekinthető</a>{" "}
						meg.
						<br />
						Korábbi, 2017. március 21-től hatályos Üzletszabályzatunk{" "}
						<a href="/wp-content/uploads/2019/05/27120635/%C3%9Czletszab%C3%A1lyzat_BM_Partner_2017.03.21_v7.docx">
							itt tekinthető
						</a>{" "}
						meg.
					</strong>
				</p>
			</LandingContainer>
		);
	}
}
